module.exports = __webpack_public_path__ + "static/media/accessory16.71669989.webp";